import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {CockpitCard} from 'shared/dtos/cockpit-card';
import {ChartDialogResidualsVsFittedComponent} from './chart-dialog-residuals-vs-fitted/chart-dialog-residuals-vs-fitted.component';
import {ChartDialogQqPlotComponent} from './chart-dialog-qq-plot/chart-dialog-qq-plot.component';
import {
  CockpitChartComponent,
  CockpitChartParentComponent,
  CockpitContentComponent
} from '../../../cockpit-shared/cockpit-content-component';

@Component({
  selector: 'app-chart-dialog-grafischer-modellcheck',
  templateUrl: './chart-dialog-grafischer-modellcheck.component.html',
  styleUrl: './chart-dialog-grafischer-modellcheck.component.scss',
  standalone: false
})
export class ChartDialogGrafischerModellcheckComponent
  extends CockpitChartParentComponent
  implements OnInit, CockpitContentComponent, AfterViewInit
{
  @ViewChild(ChartDialogResidualsVsFittedComponent)
  residualsVsFitted!: CockpitChartComponent;
  @ViewChild(ChartDialogQqPlotComponent)
  qqPlot!: CockpitChartComponent;

  chartChildren: CockpitChartComponent[];
  card: CockpitCard;

  exportCockpit?: () => void;

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor() {
    super();
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method, @typescript-eslint/no-empty-function
  async ngOnInit() {}

  ngAfterViewInit(): void {
    this.chartChildren = [this.residualsVsFitted, this.qqPlot];
  }
}
